export const ContactIDtoEmailAddress: Record<string, string> = {
    "TestContact1": "admin@dsn.com",
    "TestContact2": "nthrcontact@dsn.com",
    "TestContact3": "persona@dsn.com",
    "TestContact4": "xx_aperson_xx@dsn.com",
    "TestContact5": "uwuwuwuwuwuwuwuwu@dsn.com",
    "TestContact6": "outtaideas@dsn.com",
}